import { Link } from 'react-router-dom'

export function ForbiddenPage() {
  return (
    <div className="page page-narrow">
      <header className="page-header">
        <h1>アクセス権限がありません</h1>
        <p className="lede">この画面を表示する権限がありません。</p>
      </header>
      <section className="card">
        <Link to="/" className="btn btn-primary">
          ホームへ戻る
        </Link>
      </section>
    </div>
  )
}
